import React from 'react';
import { motion } from 'framer-motion';
import ImageSlider from './ImageSlider';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] },
});

const STATS = [
  { num: '15+',    label: 'Years Legacy' },
  { num: '46K+',   label: 'Trained Participants' },
  { num: '10.6K+', label: 'Batches Completed' },
];

export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-white">
      {/* Subtle top accent bar */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-brand-orange via-brand-orange-l to-brand-orange" />

      {/* Light background pattern */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 70% 40%, rgba(232,80,10,0.05) 0%, transparent 60%), radial-gradient(circle at 20% 80%, rgba(232,80,10,0.04) 0%, transparent 50%)',
        }}
      />

      <div className="container-xl relative z-10 pt-28 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left */}
          <div>
            <motion.div {...fadeUp(0.1)} className="inline-flex items-center gap-2 px-4 py-2 rounded-full orange-pill text-xs font-semibold tracking-[2px] uppercase mb-8">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-orange animate-pulse" />
              15-Year Safety & Engineering Legacy
            </motion.div>

            <motion.h1 {...fadeUp(0.2)} className="font-heading font-black text-5xl sm:text-6xl xl:text-7xl leading-[1.05] tracking-tight text-brand-heading mb-6">
              ENGINEERING<br />
              <span className="text-gradient">CONFIDENCE</span><br />
              INTO PROJECTS
            </motion.h1>

            <motion.p {...fadeUp(0.3)} className="text-brand-subtle text-base sm:text-lg leading-relaxed mb-3 max-w-lg font-medium">
              Third-Party Inspection · EHS Audits · Competence Training
            </motion.p>
            <motion.p {...fadeUp(0.35)} className="text-brand-subtle text-sm leading-relaxed mb-10 max-w-lg">
              Independent. Transparent. Actionable. Technical inspection, verification, testing, and conformity assessment for industrial and infrastructure markets.
            </motion.p>

            <motion.div {...fadeUp(0.45)} className="flex flex-wrap gap-4 items-center">
              <a href="#services" className="btn-primary">
                Explore Services
                <span className="group-hover:translate-x-1 transition-transform duration-200">↗</span>
              </a>
              <a href="#contact" className="btn-outline">
                Talk to Eazyworld →
              </a>
            </motion.div>

            {/* Stats */}
            <motion.div {...fadeUp(0.55)} className="flex gap-8 mt-10 pt-8 border-t border-gray-100">
              {STATS.map((s) => (
                <div key={s.label}>
                  <div className="font-heading font-black text-2xl text-gradient leading-none">{s.num}</div>
                  <div className="text-brand-subtle text-[10px] tracking-[1.5px] uppercase mt-1">{s.label}</div>
                </div>
              ))}
            </motion.div>
          </div>

          {/* Right – video */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="hidden lg:flex justify-center items-center"
          >
            <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-card-hover w-full max-w-lg">
              <video
                src="/videos/vidno1.mp4"
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>

      <div className="relative z-10 pb-10">
        <ImageSlider page="home" />
      </div>
    </section>
  );
}
